import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../../ui/custom-table";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import { CourseListApi, deleteCourseApi } from "../../../api/api";
import { toast } from "react-toastify";

function Course() {
  const dispatch = useDispatch();
  const [course, setCourse] = useState([]);
  //console.log("course", course);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const { showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // Debounce by 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const fetchCourse = async () => {
    setLoading(true);
    try {
      const search = debouncedSearch;
      const data = await CourseListApi(search, user_id, organization_id);
      //console.log("data", data);
      if (data?.data?.status === true) {
        setCourse(data?.data?.data);
        setTotalRows(data?.data?.data?.total || 0);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourse();
  }, [pagination, debouncedSearch]);

  useEffect(() => {
    if (showModal === false) {
      fetchCourse();
    }
  }, [showModal]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "course_name",
        header: "Course Name",
      },
      {
        accessorKey: "semesters",
        header: "Semesters",
        Cell: ({ cell }) =>
          cell
            .getValue()
            ?.map((s) => s.semester_name)
            .join(", "),
      },
      {
        accessorKey: "subjects",
        header: "Subjects",
        Cell: ({ cell }) =>
          cell
            .getValue()
            ?.map((s) => s.subject_name)
            .join(", "),
      },
      {
        accessorKey: "created_at",
        header: "Created At",
        Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
      },
    ],
    []
  );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDCOURSE",
        showModal: true,
      })
    );
  };

  const handleEdit = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDCOURSE",
        showModal: true,
        data: row._id,
      })
    );
  };

  const handleDelete = async (row) => {
    try {
      const data = await deleteCourseApi(row?._id, user_id, organization_id);
      if (data) {
        toast("deleted Successfully!!");
        fetchCourse();
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  return (
    <>
      <CustomTable
        columns={columns}
        data={course}
        loading={loading}
        onAddClick={handleAddClick}
        addButtonLabel="Create New"
        onEdit={handleEdit}
        showActions={true}
        onDelete={handleDelete}
        pagination={pagination}
        onPaginationChange={setPagination}
        rowCount={totalRows}
        onSearchChange={(e) => {
          setSearchTerm(e.target.value);
          setPagination({ pageIndex: 0, pageSize: 10 }); // Reset pagination on search
        }}
      />
    </>
  );
}

export default Course;
